export default {
    'base.api-error': {
        'Connection lost - the results you see may not be up to date.': 'Connection lost - the results you see may not be up to date.'
    },
    'home.header.header-event': {
        'Local Time': 'Local Time',
        'Last Update': 'Last Update',
        'N/A': 'N/A'
    },
    'home.header.header-card': {
        'Age': 'Age',
        'Stance': 'Stance',
        'Bib': 'Bib',
        'Sponsors': 'Sponsors',
        'Current Rank': 'Current Rank',
        'Podiums': 'Podiums',
        'Wins': 'Wins',
        'No live information at this time': 'No live information at this time'
    },
    'home.header.header-scores': {
        'Rank': 'Rank',
        'Total': 'Total',
        'Time': 'Time',
        'Lap': 'Lap',
        'Scores': 'Scores',
        'Current Attempt': 'Current Attempt',
        'Run Section': 'Run Section',
        'Trick': 'Trick',
        'Trick Section': 'Trick Section',
        'Improves By': 'Improves By',
        'No live information at this time': 'No live information at this time',
        '1': '1st',
        '2': '2nd',
        '3': '3rd',
        '4': '4th',
        '5': '5th',
        '6': '6th',
        '7': '7th',
        '8': '8th',
        '9': '9th',
        '10': '10th',
        '11': '11th',
        '12': '12th',
        '13': '13th',
        '14': '14th',
        '15': '15th',
        '16': '16th',
        '17': '17th',
        '18': '18th',
        '19': '19th',
        '20': '20th'
    },
    'home.table.list-switcher': {
        'Start List': 'Start List',
        'Leaderboard': 'Leaderboard'
    },
    'home.table.start-list': {
        'No': 'No',
        'Bib': 'Bib',
        'Name': 'Name',
        'Name/Nation': 'Name/Nation',
        'Age': 'Age',
        'Stance': 'Stance',
        'Sponsor': 'Sponsor',
        'Hometown': 'Hometown',
        'Start List': 'Start List'
    },
    'home.table.leaderboard': {
        'Rk': 'Rk',
        'Bib': 'Bib',
        'Name': 'Name',
        'Name/Nation': 'Name/Nation',
        'Scores': 'Scores',
        'Total': 'Total',
        'Needs': 'Needs',
        'No live information at this time': 'No live information at this time',
        'Leaderboard': 'Leaderboard',
        '1': '1st',
        '2': '2nd',
        '3': '3rd',
        '4': '4th',
        '5': '5th',
        '6': '6th',
        '7': '7th',
        '8': '8th',
        '9': '9th',
        '10': '10th',
        '11': '11th',
        '12': '12th',
        '13': '13th',
        '14': '14th',
        '15': '15th',
        '16': '16th',
        '17': '17th',
        '18': '18th',
        '19': '19th',
        '20': '20th'
    },
    'home.duel': {
        'Rk': 'Rk',
        'Bib': 'Bib',
        'Name': 'Name',
        'Name/Nation': 'Name/Nation',
        'Scores': 'Scores',
        'Total': 'Total',
        'Needs': 'Needs',
        'No live information at this time': 'No live information at this time',
        'Leaderboard': 'Leaderboard',
        '1': '1st',
        '2': '2nd',
        '3': '3rd',
        '4': '4th',
        '5': '5th',
        '6': '6th',
        '7': '7th',
        '8': '8th',
        '9': '9th',
        '10': '10th',
        '11': '11th',
        '12': '12th',
        '13': '13th',
        '14': '14th',
        '15': '15th',
        '16': '16th',
        '17': '17th',
        '18': '18th',
        '19': '19th',
        '20': '20th'
    },
    'home.duel.competitor': {
        'Rank': 'Rank',
        'Total': 'Total',
        'Time': 'Time',
        'Profile': 'Profile'
    },
};



// WEBPACK FOOTER //
// ./src/translate/en_US/index.js